import { useState, useEffect } from 'react';

/**
 * Hook to detect if the device is mobile based on screen width
 * Uses the same breakpoint as Tailwind's 'lg' (1024px)
 *
 * @param {number} breakpoint - Width threshold in pixels (default: 1024)
 * @returns {boolean} - True if screen width is below breakpoint
 */
export function useIsMobile(breakpoint = 1024) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < breakpoint;
    }
    return false;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Check on mount
    handleResize();

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
